<template>
  <div class="bread">
    <ul>
      <li class="second-title-li" @click="$parent.goDetail(0)" v-if="!($route.name == 'Material' || $route.name == 'Template') || !$route.query.folder">
        <span class="bread-text" data-id="0">全部</span>
        <span
          class="iconfont icon-Unfold-selected1"
          v-if="breadList.length"
        ></span>
      </li>
      <li
        class="second-title-li"
        :class="[index === breadList.length - 1 ? 'purple-active' : '']"
        v-for="(bread, index) in breadList"
        :key="bread.id"
        @click="$parent.goDetail(bread)"
      >
        <span class="bread-text" :data-id="bread.id">{{ bread.name }}</span>
        <span
          v-if="breadList.length"
          class="iconfont icon-Unfold-selected1"
          v-show="index !== breadList.length - 1"
        ></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["breadList"],
};
</script>

<style lang="scss" scoped>
.bread {
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin: 16px 0;
  ul {
    display: flex;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #838089;
    }
    .purple-active {
      color: #2d2d32;
      .iconfont {
        color: #2d2d32;
      }
    }
  }
}
</style>
